<script lang="ts">
    import type {IMaintenance} from "../data";
    import FormVehicle from "./FormVehicle.svelte";
    import Revision from "./products/Revision.svelte";

    export let maintenance: IMaintenance;
    export let cities: Array<any> = [];

    export let keys = {
        silver: {
            description: 'descSilver',
            precioTotal: 'precioSilverTotal',
            precioNeto: 'precioSilverNeto',
            porcDescuento: 'porcDescuentoSilver',
            vin: 'vin',
            codModeloTasa: 'codModeloTasa',
            ciudad: 'ciudad',
        },
        gold: {
            description: 'descGold',
            precioTotal: 'precioGoldTotal',
            precioNeto: 'precioGoldNeto',
            porcDescuento: 'porcDescuentoGold',
            vin: 'vin',
            codModeloTasa: 'codModeloTasa',
            ciudad: 'ciudad',
        }
    };

    export let key: string;

    export let info = {};

    export let detailCmpt: any;

    export function getInfo() {
        info = {};
        Object.keys(keys[key]).forEach((k) => {
            info[k] = maintenance[keys[key][k]];
        });
        return info;
    }

    async function showDetail(km) {
        const details = await fetch(`/backend/api/v2/ecommerce/mantenimiento-prepagado-revision/kilometros/${km}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(r => r.json());
        detailCmpt.$set({
            open: true,
            details
        });
    }

</script>
{#if maintenance}
    <div class="py-1 max-w-900px">
        <div class="mb-1">
            <strong>Revisiones Incluidas</strong>
        </div>
        <table class="nissan-table w-100">
            {#each info.description as item}
                <tr>
                    <td class="p-iii">Revisión {item} km</td>
                    <td class="p-iii">
                        <div class="box-r sx-i pointer" on:click={()=>showDetail(item)}>
                            <span style="font-size: 14px">Detalle</span>
                            <img height="15" src="/static/storefront/pix/icons/chevron-red.svg" alt="CTA">
                        </div>
                    </td>
                </tr>
            {/each}
        </table>
    </div>
    <Revision bind:this={detailCmpt}/>
{:else}
    <FormVehicle title="Conoce los detalles del plan ideal para tu Nissan"
                 button="Detalles de mi plan"
                 {cities}
                 on:search/>
{/if}
